import { rem } from 'polished'
import React, { useMemo, useCallback } from 'react'
import styled from 'styled-components'

import TextButton from 'LuxKit/Button/TextButton'
import { mediaQueryUp } from 'components/utils/breakpoint'
import Group from 'components/utils/Group'
import { useScreenSizeOnly } from 'hooks/useScreenSize'
import TransportItemContent from 'tripPlanner/components/ItemCard/Transport/TransportItemContent'
import TripItemSummary from 'tripPlanner/components/TripModal/TripItems/Summary'
import useOpenModal from 'tripPlanner/hooks/View/useOpenModal'
import { TransportItem } from 'tripPlanner/types/tripItem'
import AboveCardCloseButton from '../Common/AboveCardCloseButton'

const CardContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-around;
`

const Container = styled.div`
  position: relative;
  width: 100%;
  background-color: white;
  max-width: ${rem(340)};
  padding: ${rem(16)};
  pointer-events: auto;
  box-shadow: ${props => props.theme.shadow.bottom.medium};

  ${mediaQueryUp.largeDesktop} {
    max-width: ${rem(700)};
    padding: ${rem(24)};
  }
`

interface Props {
  className?: string
  item: TransportItem
  showCloseButton?: boolean
  onClose?: () => void
}

const TransportItemSummaryCard = React.forwardRef<HTMLDivElement, Props>(
  ({ className, item, showCloseButton, onClose }, ref) => {
    const openModal = useOpenModal()
    const openDetailsModal = useMemo(() => {
      return () => openModal(TripItemSummary, { item })
    }, [item, openModal])

    const isMobileScreen = useScreenSizeOnly('mobile')

    const showDetail = useCallback(
      (e: React.MouseEvent<HTMLButtonElement>) => {
        openModal(TripItemSummary, { item })
        e.stopPropagation()
      },
      [item, openModal],
    )

    return (
      <CardContainer className={className}>
        <Container ref={ref}>
          {showCloseButton && (
            <AboveCardCloseButton onClick={onClose} />
          )}
          <Group
            direction="vertical"
            gap={8}
            onClick={isMobileScreen ? openDetailsModal : undefined}
            horizontalAlign="end"
          >
            <TransportItemContent item={item} variant="mapSummary" />
            <TextButton
              kind="tertiary"
              size="small"
              variant="default"
              horizontalOutdent="end"
              nonInteractable
              onClick={showDetail}
            >
              View details
            </TextButton>
          </Group>
        </Container>
      </CardContainer>
    )
  },
)

TransportItemSummaryCard.displayName = 'RouteItemSummaryCard'
export default TransportItemSummaryCard
